import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { Table, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import formatMoney from '~helpers/currency';
import { formatUppercaseLetters, processBookingSystem } from '~helpers/change-log';
import { dayFormatType, formatDay } from '~helpers/day';
/* eslint-disable   */
export default function table({ rowKeys, list }) {
  const [selectedRowKeys, setselectedRowKeys] = useState([]);
  const { t } = useTranslation();
  const history = useHistory();

  const rowSelection = {
    selectedRowKeys,
    onChange: rowkeys => {
      setselectedRowKeys(rowkeys);
    },
  };

  useEffect(() => {
    rowKeys && rowKeys(selectedRowKeys);
  }, [selectedRowKeys]);

  const getColumns = () => {
    var columns = [
      {
        title: t('cms.reconciliation.list.table.booking_reference'),
        dataIndex: 'booking_reference',
        fixed: 'left',
        width: 180,
        key: 'booking_reference',
        render: (text, record) => get(record, 'referenceId') || '-',
      },
      {
        title: t('cms.reconciliation.list.table.booking_id_system'),
        dataIndex: 'landlordApplicationId',
        width: 180,
        key: 'landlordApplicationId',
        render: (text, record) => get(record, 'landlordApplicationId') || '-',
      },
      {
        title: t('cms.reconciliation.list.table.student_passport_name'),
        dataIndex: 'student_passport_name',
        key: 'student_passport_name',
        width: 180,
        render: (text, record) => get(record, 'student.firstName') || '-',
      },
      {
        title: t('cms.reconciliation.list.table.email_address'),
        dataIndex: 'email_address',
        key: 'email_address',
        width: 120,
        render: (text, record) => get(record, 'student.emailAddress') || '-',
      },
      {
        title: t('cms.reconciliation.list.table.destination_city'),
        dataIndex: 'destination_city',
        key: 'destination_city',
        width: 180,
        render: (text, record) => get(record, 'city.name') || '-',
      },
      {
        title: t('cms.reconciliation.list.table.landlord_name'),
        dataIndex: 'landlord_name',
        width: 200,
        key: 'landlord_name',
        render: (text, record) => (
          <div>{`${get(record, 'completedXbooking.landlordName') || '-'}`}</div>
        ),
      },
      {
        title: t('cms.reconciliation.list.table.property_name'),
        dataIndex: 'property_name',
        key: 'property_name',
        width: 200,
        render: (text, record) => get(record, 'completedXbooking.propertyName') || '-',
      },
      {
        title: t('cms.reconciliation.list.table.room_name'),
        dataIndex: 'room_name',
        key: 'room_name',
        width: 140,
        render: (text, record) => get(record, 'completedXbooking.roomName') || '-',
      },
      {
        title: t('cms.reconciliation.list.table.listing_price'),
        dataIndex: 'listing_price',
        key: 'listing_price',
        width: 140,
        render: (text, record) =>
          get(record, 'completedXbooking.unitPrice')
            ? formatMoney(
                get(record, 'completedXbooking.unitPrice'),
                get(record, 'completedXbooking.currency'),
              ) +
              `/${
                get(record, 'city.country.billingCycle')?.toLowerCase() === 'weekly'
                  ? 'week'
                  : 'month'
              }`
            : '-',
      },
      {
        title: t('cms.reconciliation.list.table.completed_date'),
        dataIndex: 'completed_date',
        key: 'completed_date',
        width: 150,
        render: (text, record) =>
          get(record, 'completedAt')
            ? formatDay(dayFormatType.UKFORMAT, get(record, 'completedAt'))
            : '-',
      },
      {
        title: t('cms.reconciliation.list.table.actual_move_in_date'),
        dataIndex: 'actual_move_in_date',
        key: 'actual_move_in_date',
        width: 180,
        render: (text, record) =>
          get(record, 'finalMoveInDate')
            ? formatDay(dayFormatType.UKFORMAT, get(record, 'finalMoveInDate'))
            : '-',
      },
      {
        title: t('cms.reconciliation.list.table.actual_move_out_date'),
        dataIndex: 'actual_move_out_date',
        key: 'actual_move_out_date',
        width: 180,
        render: (text, record) =>
          get(record, 'finalMoveOutDate')
            ? formatDay(dayFormatType.UKFORMAT, get(record, 'finalMoveOutDate'))
            : '-',
      },
      {
        title: t('cms.reconciliation.list.table.tenancy_length_weeks'),
        dataIndex: 'tenancy_length_weeks',
        key: 'tenancy_length_weeks',
        width: 130,
        render: (text, record) => get(record, 'tenancyLength.weeks') || '-',
      },
      {
        title: t('cms.reconciliation.list.table.tenancy_length_days'),
        dataIndex: 'tenancy_length_days',
        key: 'tenancy_length_days',
        width: 130,
        render: (text, record) => get(record, 'tenancyLength.days') || '-',
      },
      {
        title: t('cms.reconciliation.list.table.final_price'),
        dataIndex: 'final_price',
        key: 'final_price',
        width: 100,
        render: (text, record) =>
          get(record, 'finalPrice')
            ? formatMoney(get(record, 'finalPrice'), get(record, 'completedXbooking.currency'))
            : '-',
      },
      {
        title: t('cms.booking.manual_property.detail.commission_info.total_commission_charged'),
        key: 'totalCommissionCharged',
        width: 150,
        render: (text, record) =>
          get(record, 'completedXbooking.commission.totalCommissionValue')
            ? formatMoney(
                get(record, 'completedXbooking.commission.totalCommissionValue'),
                get(record, 'completedXbooking.currency'),
              )
            : '-',
      },
      {
        title: t('cms.reconciliation.list.table.commission_value'),
        dataIndex: 'commission_value',
        key: 'commission_value',
        width: 150,
        render: (text, record) =>
          get(record, 'booking.commissionData.tier.calculationValue') || '-',
      },
      {
        title: t('cms.reconciliation.list.table.commission_type'),
        dataIndex: 'commission_type',
        key: 'commission_type',
        width: 150,
        render: (text, record) => get(record, 'booking.commissionData.tier.calculationType') || '-',
      },
      {
        title: t('cms.reconciliation.list.table.currency'),
        dataIndex: 'currency',
        key: 'currency',
        width: 100,
        render: (text, record) => get(record, 'completedXbooking.currency') || '-',
      },
      {
        title: t('cms.reconciliation.list.table.landlord_booking_status'),
        dataIndex: 'landlord_booking_status',
        width: 150,
        key: 'landlord_booking_status',
        render: (text, record) =>
          formatUppercaseLetters(
            get(record, 'landlordBookingStatus')?.toLowerCase?.()?.split?.('_')?.join?.(' '),
          ) || '-',
      },
      {
        title: t('cms.reconciliation.list.table.secondary_landlord_booking_status'),
        dataIndex: 'secondary_landlord_booking_status',
        key: 'secondary_landlord_booking_status',
        width: 180,
        render: (text, record) =>
          formatUppercaseLetters(
            get(record, 'secondaryLandlordBookingStatus')
              ?.toLowerCase?.()
              ?.split?.('_')
              ?.join?.(' '),
          ) || '-',
      },
      {
        title: t('cms.reconciliation.list.table.booking_consultant'),
        dataIndex: 'booking_consultant',
        key: 'booking_consultant',
        width: 100,
        render: (text, record) => get(record, 'ownedBy') || '-',
      },
      {
        title: t('cms.reconciliation.list.table.booking_system'),
        dataIndex: 'booking_system',
        key: 'booking_system',
        width: 150,
        render: (text, record) => processBookingSystem(get(record, 'landlordApplicationSystem')),
      },
      {
        title: t('cms.reconciliation.list.table.supply_team_notes'),
        dataIndex: 'supply_team_notes',
        key: 'supply_team_notes',
        width: 200,
        render: (text, record) => {
          const val = get(record, 'opportunityNote.reconciliationNote');
          let dom = val || '-';
          if (val?.length >= 30) {
            dom = (
              <Tooltip placement="top" title={val}>
                {val.slice(0, 30) + '...'}
              </Tooltip>
            );
          }
          return dom;
        },
      },
      {
        title: t('cms.reconciliation.list.table.invoice_number'),
        dataIndex: 'invoice_number',
        key: 'invoice_number',
        width: 200,
        render: (text, record) => get(record, 'completedXbooking.commission.invoiceNumber') || '-',
      },

      {
        title: t('cms.reconciliation.list.table.actual_invoice_value'),
        dataIndex: 'actual_invoice_value',
        key: 'actual_invoice_value',
        width: 170,
        render: (text, record) =>
          get(record, 'completedXbooking.commission.actualInvoicedValue')
            ? formatMoney(
                get(record, 'completedXbooking.commission.actualInvoicedValue'),
                get(record, 'completedXbooking.currency'),
              )
            : '-',
      },
      {
        title: t('cms.reconciliation.list.table.destination_market'),
        dataIndex: 'destination_market',
        key: 'destination_market',
        width: 100,
        render: (text, record) => get(record, 'city.country.market') || '-',
      },

      {
        title: t('cms.reconciliation.list.table.created_date'),
        dataIndex: 'created_date',
        key: 'created_date',
        width: 150,
        render: (text, record) =>
          get(record, 'createdAt')
            ? formatDay(dayFormatType.UKFORMAT, get(record, 'createdAt'))
            : '-',
      },

      // {暂时不加 后端还没做
      //   title: t('cms.reconciliation.list.table.reconciliation_owner'),
      //   dataIndex: 'reconciliation_owner',
      //   width: 200,
      //   render: (text, record) => get(record, 'ownedBy') || '-',
      // },

      {
        title: t('cms.referral.partner.list.column.actions'),
        dataIndex: 'actions',
        key: 'actions',
        width: 80,
        fixed: 'right',
        render: (_text, record) => (
          <div className="partner-page__body__list__column-body">
            <a
              role="button"
              tabIndex="0"
              onClick={() => history.push(`booking-with-consultant/${get(record, 'id')}`)}
            >
              {t('cms.form.label.view')}
            </a>
          </div>
        ),
      },
    ];

    return columns;
  };

  return (
    <Table
      rowSelection={rowSelection}
      columns={getColumns()}
      rowKey={record => record.id}
      scroll={{ x: 3000 }}
      dataSource={list.payload || []}
      pagination={false}
    />
  );
}
